const URL_BASE=process.env.REACT_APP_API;

export const URL_USERS_LIST=`${URL_BASE}/users`;